import Cookie from 'js-cookie';

import Settings from 'source/lib/settings_model';
import messages from 'messages';

import loadScript from './script';

async function loadLanguage(languageCode) {
    const availableLangages = Settings.get('General.AvailableLanguages', [[languageCode]]);
    const setLanguage = languageCode || Settings.get('General.LanguageCode');

    if (availableLangages.filter(lang => lang[0] === setLanguage).length < 1) {
        return Promise.resolve(false);
    }
    if (setLanguage !== Settings.get('General.LanguageCode')) {
        Settings.set({
            General: {
                LanguageCode: setLanguage,
            },
        });

        const options = {
            path: Settings.get('General.LanguageCookiePath'),
            expires: Settings.get('General.LanguageCookieExpires'),
            secure: Settings.get('General.LanguageCookieSecure'),
            sameSite: Settings.get('General.LanguageCookieSameSite'),
        };

        Cookie.set(Settings.get('General.LanguageCookieName'), setLanguage, options);
    }
    const staticUrl = Settings.get('App.StaticUrl');
    const langUrl = `${staticUrl}i18n/${setLanguage}.js`;
    const loadPromises = [loadScript(langUrl, {
        noCatch: true,
    })];
    try {
        window.moment.lang(setLanguage);
    } catch (e) {
        loadPromises.push(loadScript(`${staticUrl}l10n/plugins/moment/lang/${setLanguage}.js`, {
            noCatch: true,
        }));
    }

    await Promise.all(loadPromises);
    const body = document.querySelector('body');

    body.className = body.className.replace(/lang-\S+/g, '');
    body.classList.add(`lang-${setLanguage}`);
    if (languageCode) {
        await Settings.startUpdate(true);
    }
    messages.setDict();
    return Promise.resolve(true);
}

export default loadLanguage;
